import { checkCollision } from './gameUtils';

const evaluatePosition = (board, tetromino) => {
  try {
    const simulatedBoard = board.map(row => [...row]);
    
    if (tetromino.pos.x < -2 || tetromino.pos.x >= board[0].length || 
        tetromino.pos.y >= board.length) {
      return -Infinity;
    }
    
    tetromino.matrix.forEach((row, y) => {
      row.forEach((value, x) => {
        if (value) {
          const newY = y + tetromino.pos.y;
          const newX = x + tetromino.pos.x;
          if (newY >= 0 && newY < board.length && newX >= 0 && newX < board[0].length) {
            simulatedBoard[newY][newX] = 1;
          }
        }
      });
    });

    let score = 0;
    
    const heights = [];
    for (let x = 0; x < board[0].length; x++) {
      let height = 0;
      for (let y = 0; y < board.length; y++) {
        if (simulatedBoard[y][x]) {
          height = board.length - y;
          break;
        }
      }
      heights.push(height);
    }

    const completedLines = simulatedBoard.filter(row => row.every(cell => cell !== 0)).length;
    score += completedLines * 1000;

    let holes = 0;
    for (let x = 0; x < board[0].length; x++) {
      let foundBlock = false;
      for (let y = 0; y < board.length; y++) {
        if (simulatedBoard[y][x]) {
          foundBlock = true;
        } else if (foundBlock) {
          holes++;
        }
      }
    }
    score -= holes * 1000;

    let roughness = 0;
    for (let i = 0; i < heights.length - 1; i++) {
      roughness += Math.abs(heights[i] - heights[i + 1]);
    }
    score -= roughness * 300;

    const maxHeight = Math.max(...heights);
    // eslint-disable-next-line no-unused-vars
    const avgHeight = heights.reduce((sum, h) => sum + h, 0) / heights.length;
    
    if (maxHeight > board.length * 0.6) {
      score -= Math.pow(maxHeight - board.length * 0.6, 2) * 500;
    }
    let wallTouches = 0;
    tetromino.matrix.forEach((row, y) => {
      row.forEach((value, x) => {
        if (value) {
          const newX = x + tetromino.pos.x;
          if (newX === 0 || newX === board[0].length - 1) {
            wallTouches++;
          }
        }
      });
    });
    score += wallTouches * 100;
    let contacts = 0;
    tetromino.matrix.forEach((row, y) => {
      row.forEach((value, x) => {
        if (value) {
          const newY = y + tetromino.pos.y;

          const newX = x + tetromino.pos.x;

          if (newY + 1 < board.length && board[newY + 1][newX]) contacts++;

          if (newX > 0 && board[newY][newX - 1]) contacts++;

          if (newX < board[0].length - 1 && board[newY][newX + 1]) contacts++;
        }
      });
    });
    score += contacts * 200;

    const bottomRow = board.length - 1;
    let bottomPlacements = 0;
    tetromino.matrix.forEach((row, y) => {
      row.forEach((value, x) => {
        if (value && y + tetromino.pos.y === bottomRow) {
          bottomPlacements++;
        }
      });
    });
    score += bottomPlacements * 500;

    let isBlockingHole = false;
    const tetrominoBottom = tetromino.pos.y + tetromino.matrix.length;
    for (let x = 0; x < board[0].length; x++) {
      let foundHole = false;
      for (let y = 0; y < tetrominoBottom; y++) {
        if (!simulatedBoard[y][x] && y < board.length) {
          foundHole = true;
        }
        if (foundHole && y >= tetromino.pos.y && y < tetrominoBottom) {
          isBlockingHole = true;
          break;
        }
      }
    }
    if (isBlockingHole) {
      score -= 2000;
    }

    return score;
  } catch (error) {
    return -Infinity;
  }
};

export const findBestMove = (board, tetromino) => {
  try {
    let bestScore = -Infinity;
    let bestMove = { x: 0, rotation: 0 };
    
    const maxRotations = tetromino.matrix.length === tetromino.matrix[0].length ? 4 : 2;
    
    for (let rotation = 0; rotation < maxRotations; rotation++) {
      let rotatedMatrix = tetromino.matrix;
      for (let r = 0; r < rotation; r++) {
        rotatedMatrix = rotatedMatrix.map((row, i) => 
          row.map((val, j) => rotatedMatrix[rotatedMatrix.length - 1 - j][i])
        );
      }
      
      for (let x = -2; x < board[0].length; x++) {
        let y = 0;
        
        while (y < board.length) {
          const tetrominoState = {
            matrix: rotatedMatrix,
            pos: { x, y: y + 1 },
            color: tetromino.color
          };
          
          if (checkCollision(board, tetrominoState, tetrominoState.pos)) {
            break;
          }
          y++;
        }
        
        const tetrominoToEvaluate = {
          matrix: rotatedMatrix,
          pos: { x, y },
          color: tetromino.color
        };
        
        const score = evaluatePosition(board, tetrominoToEvaluate);
        
        if (score > 3000) {
          return { x, rotation };
        }
        
        if (score > bestScore) {
          bestScore = score;
          bestMove = { x, rotation };
        }
      }
    }
    
    return bestMove;
  } catch (error) {
    return { x: Math.floor(board[0].length / 2) - 1, rotation: 0 };
  }
}; 